import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "max-w-[1040px]" }
const _hoisted_2 = {
  key: 0,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_3 = { class: "flex justify-end" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "text-gray-900 font-medium truncate" }
const _hoisted_6 = { class: "truncate" }
const _hoisted_7 = { class: "flex justify-end" }
const _hoisted_8 = {
  key: 1,
  class: "rounded-xl border border-gray-200 bg-white px-6 py-10 shadow-sm"
}
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = { class: "w-full" }

import { Bars3Icon, XCircleIcon } from '@heroicons/vue/24/outline'
import Sortable from 'sortablejs'
import { computed, onMounted, ref, watch } from 'vue'

import EmptyState from '@/components/neue/EmptyState'
import FormElement from '@/components/neue/FormElement'
import FormSection from '@/components/neue/FormSection'
import InputArea from '@/components/neue/InputArea'
import InputField from '@/components/neue/InputField'
import MultiSelectInput from '@/components/neue/MultiSelectInput'
import NeueButton from '@/components/neue/NeueButton'
import NeueLoading from '@/components/neue/NeueLoading'
import NeueTablist from '@/components/neue/NeueTablist'
import NeueToggle from '@/components/neue/NeueToggle'
import SelectInput from '@/components/neue/SelectInput'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader'
import TablistRow from '@/components/neue/TablistRow'
import TheModal from '@/components/TheModal.vue'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'

const included = 'autofill_instruction_helpers,restrictions,variant_preference_metadata,membership_tier_package_pairs'


export default {
  __name: 'StorePackages',
  props: ['id'],
  setup(__props) {

const loading = ref(true)
const modal = ref({ open: false, package: null })
const props = __props

const cols = [
  { width: 'minmax(200px, 2fr)' },
  { width: 'minmax(110px, 1fr)' },
  { width: 'minmax(110px, 1fr)' },
  { width: '130px' }
]
const store = computed(() => mapRelationship({ type: 'store', id: props.id }))
const rows = ref(null)

const packagesList = ref([])
const packages = computed(() =>
  mapRelationships(packagesList.value).sort((a, b) => a.attributes.order - b.attributes.order)
)
// TODO(alicja): just assuming that they're loaded by the categories module, idk
// another load seems a bit wasteful
const categories = computed(() =>
  mapRelationships(store.value?.relationships.categories.data)
    .filter(x => x.attributes.type !== 'UpsellCategory')
    .sort((a, b) => a.attributes.order_value - b.attributes.order_value)
)

const packagePairs = pkg =>
  mapRelationships(pkg.relationships.membership_tier_package_pairs?.data).map(x => ({
    id: x.id,
    tierId: x.relationships.membership_tier.data?.id
  }))

const storeTierIds = computed(() => (store.value?.relationships.membership_tiers?.data || []).map(x => x.id))

// A tier already tied to the package stays listed even if the store no longer offers it,
// so the saved selection always shows and can be removed.
const tierOptions = computed(() =>
  mapType('membership_tier')
    .filter(x => storeTierIds.value.includes(x.id) || modal.value.pairs?.some(p => p.tierId === x.id))
    .map(x => ({ name: x.attributes.tier_name, value: x.id }))
)

const tierLabel = pkg => {
  if (pkg.attributes.available_for_all_membership_tiers !== false) return 'All'
  return pkg.relationships.membership_tier_package_pairs?.data?.length ? 'Selected tiers' : 'None'
}

const pairAttributes = ({ availableForAll, tierIds, pairs }) => {
  if (availableForAll) return []
  const added = tierIds.filter(id => !pairs.some(p => p.tierId === id)).map(id => ({ membership_tier_id: id }))
  const removed = pairs.filter(p => !tierIds.includes(p.tierId)).map(p => ({ id: p.id, _destroy: true }))
  return [...added, ...removed]
}

watch(rows, () => {
  if (rows.value)
    new Sortable(rows.value, {
      handle: '.cursor-move',
      ghostClass: 'bg-gray-200',
      dragClass: 'bg-white',
      onSort(e) {
        const list = packages.value
        const moved = list.splice(e.oldIndex, 1)[0]
        list.splice(e.newIndex, 0, moved)
        list.map((x, i) =>
          api.call('PUT', `stores/${props.id}/packages/${x.id}`, {
            package: {
              order: i
            }
          })
        )
      }
    })
})

onMounted(async () => {
  api.call('GET', 'membership_tiers?included=none&limit=50')
  const response = await api.call('GET', `stores/${props.id}/packages?included=${included}`)
  packagesList.value = response.data.data
  loading.value = false
})

const editPackage = pkg => {
  modal.value = {
    open: true,
    package: pkg,
    enabled: pkg.attributes.is_on,
    name: pkg.attributes.package_name,
    description: pkg.attributes.package_description,
    minimumItems: pkg.attributes.minimum_items_count,
    minimumPrice: (pkg.attributes.minimum_price.cents / 100).toFixed(2),
    autofill: pkg.attributes.autofill_on_selection,
    availableForAll: pkg.attributes.available_for_all_membership_tiers !== false,
    pairs: packagePairs(pkg),
    tierIds: packagePairs(pkg).map(x => x.tierId),
    helpers: mapRelationships(pkg.relationships.autofill_instruction_helpers.data)
      .filter(
        x => x.attributes.autofill_type === 'CategoryAutofill'
        // only supporting category autofills for now
      )
      .map(x => ({ id: x.id, categoryId: x.attributes.object_to_autofill_id?.toString(), count: x.attributes.count })),
    restrictions: mapRelationships(pkg.relationships.restrictions.data).map(x => ({
      id: x.id,
      categoryId: x.attributes.restriction_id?.toString(),
      count: x.attributes.integer_value
    })),
    variants: mapRelationships(pkg.relationships.variant_preference_metadata.data).map(x => ({
      id: x.id,
      key: x.attributes.key,
      value: x.attributes.string_value
    }))
  }
}

const modalValid = computed(() => modal.value.name)

const saveModal = () => {
  api.call('PUT', `stores/${props.id}/packages/${modal.value.package.id}?included=${included}`, {
    package: {
      is_active: true,
      is_on: modal.value.enabled,
      package_name: modal.value.name,
      package_description: modal.value.description,
      minimum_items_count: modal.value.minimumItems,
      minimum_price_cents: modal.value.minimumPrice * 100,
      autofill_on_selection: modal.value.autofill,
      available_for_all_membership_tiers: modal.value.availableForAll,
      membership_tier_package_pairs_attributes: pairAttributes(modal.value),
      autofill_instruction_helpers_attributes: modal.value.helpers.map(x => ({
        autofill_type: 'CategoryAutofill',
        object_to_autofill_class_name: 'Category',
        _destroy: x.destroy,
        id: x.id,
        object_to_autofill_id: x.categoryId,
        count: x.count
      })),
      restrictions_attributes: modal.value.restrictions.map(x => ({
        restriction_type: 'category',
        restriction_class_name: 'Category',
        _destroy: x.destroy,
        id: x.id,
        restriction_id: x.categoryId,
        integer_value: x.count
      })),
      variant_preference_metadata_attributes: modal.value.variants.map(x => ({
        _destroy: x.destroy,
        id: x.id,
        key: x.key,
        string_value: x.value
      }))
    }
  })
  modal.value.open = false
}

const addPackage = () => {
  api
    .call('POST', `stores/${props.id}/packages`, {
      package: { is_active: false, order: packages.value.reduce((max, x) => Math.max(max, x.attributes.order), -1) + 1 }
    })
    .then(response => {
      packagesList.value.push(response.data.data)
      editPackage(response.data.data)
    })
}

const deletePackage = pkg => {
  if (!confirm(`Delete ${pkg.attributes.package_name}?`)) return
  api.call('DELETE', `stores/${props.id}/packages/${pkg.id}`)
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NeueLoading), { loading: loading.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(SettingsSection, {
            title: "Your packages",
            description: "A package is a set of minimum requirements and autofill rules, so you can offer a product mix as one \"package.\"",
            plain: ""
          }, {
            default: _withCtx(() => [
              (packages.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_unref(NeueTablist), null, {
                      head: _withCtx(() => [
                        _createVNode(_unref(TablistHeader), null, {
                          default: _withCtx(() => [
                            _createVNode(TablistGrid, {
                              columns: cols,
                              header: "",
                              class: "items-center"
                            }, {
                              default: _withCtx(() => [
                                _cache[15] || (_cache[15] = _createElementVNode("div", null, "Name", -1)),
                                _cache[16] || (_cache[16] = _createElementVNode("div", null, "Status", -1)),
                                _cache[17] || (_cache[17] = _createElementVNode("div", null, "Tiers", -1)),
                                _createElementVNode("div", _hoisted_3, [
                                  _createVNode(_unref(NeueButton), {
                                    type: "secondary",
                                    onClick: _withModifiers(addPackage, ["prevent"])
                                  }, {
                                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                      _createTextVNode("+ Package", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          ref_key: "rows",
                          ref: rows,
                          class: "divide-y divide-gray-200"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packages.value, (pkg) => {
                            return (_openBlock(), _createBlock(_unref(TablistRow), {
                              key: pkg.id,
                              class: "cursor-pointer",
                              onClick: $event => (editPackage(pkg))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(TablistGrid, {
                                  columns: cols,
                                  class: "items-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_4, [
                                      _createElementVNode("div", {
                                        class: "cursor-move -ml-4 px-3 -mt-2 -mb-2 py-2",
                                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                                      }, [
                                        _createVNode(_unref(Bars3Icon), { class: "h-5 w-5" })
                                      ]),
                                      _createElementVNode("span", _hoisted_5, _toDisplayString(pkg.attributes.package_name), 1)
                                    ]),
                                    _createElementVNode("div", null, _toDisplayString(pkg.attributes.is_on ? 'Enabled' : 'Disabled'), 1),
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(tierLabel(pkg)), 1),
                                    _createElementVNode("div", _hoisted_7, [
                                      _createVNode(_unref(XCircleIcon), {
                                        class: "h-6 w-6 hover:text-black shrink-0",
                                        onClick: _withModifiers($event => (deletePackage(pkg)), ["stop"])
                                      }, null, 8, ["onClick"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ], 512)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (!packages.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_unref(EmptyState), { plural: "packages" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NeueButton), {
                          type: "secondary",
                          onClick: _withModifiers(addPackage, ["prevent"])
                        }, {
                          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                            _createTextVNode("+ Package", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(TheModal, {
      "is-open": modal.value.open,
      "modal-title": "Package",
      onCloseModal: _cache[13] || (_cache[13] = $event => (modal.value.open = false))
    }, {
      main: _withCtx(() => [
        _createVNode(_unref(FormSection), null, {
          default: _withCtx(() => [
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NeueToggle), {
                  modelValue: modal.value.enabled,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((modal.value.enabled) = $event)),
                  name: "Enabled"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_unref(InputField), {
                  modelValue: modal.value.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((modal.value.name) = $event)),
                  name: "Name"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_unref(InputArea), {
                  modelValue: modal.value.description,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((modal.value.description) = $event)),
                  name: "Description"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), { size: "3" }, {
              default: _withCtx(() => [
                _createVNode(_unref(InputField), {
                  modelValue: modal.value.minimumItems,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((modal.value.minimumItems) = $event)),
                  name: "Minimum number of items"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), { size: "3" }, {
              default: _withCtx(() => [
                _createVNode(_unref(InputField), {
                  modelValue: modal.value.minimumPrice,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((modal.value.minimumPrice) = $event)),
                  name: "Minimum price",
                  prefix: "$"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NeueToggle), {
                  modelValue: modal.value.autofill,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((modal.value.autofill) = $event)),
                  name: "Autofill on selection"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormElement), null, {
              default: _withCtx(() => [
                _createVNode(_unref(NeueToggle), {
                  modelValue: modal.value.availableForAll,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((modal.value.availableForAll) = $event)),
                  name: "Available for all membership tiers"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (!modal.value.availableForAll)
              ? (_openBlock(), _createBlock(_unref(FormElement), { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(MultiSelectInput), {
                      modelValue: modal.value.tierIds,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((modal.value.tierIds) = $event)),
                      options: tierOptions.value,
                      placeholder: "Select membership tiers"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_9, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-xl font-medium mb-2" }, "Autofill", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modal.value.helpers.filter(x => !x.destroy), (helper) => {
            return (_openBlock(), _createBlock(_unref(FormSection), null, {
              default: _withCtx(() => [
                _createVNode(_unref(FormElement), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_unref(SelectInput), {
                          modelValue: helper.categoryId,
                          "onUpdate:modelValue": $event => ((helper.categoryId) = $event),
                          options: categories.value.map(x => ({ name: x.attributes.category_name, value: x.id })),
                          name: "Category",
                          class: "mb-2"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]),
                        _createVNode(_unref(InputField), {
                          modelValue: helper.count,
                          "onUpdate:modelValue": $event => ((helper.count) = $event),
                          name: "Count"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createVNode(_unref(XCircleIcon), {
                        class: "cursor-pointer h-8 w-8 shrink-0 ml-4 mt-3 hover:text-black",
                        onClick: $event => (helper.destroy = true)
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 256)),
          _createVNode(_unref(NeueButton), {
            onClick: _cache[9] || (_cache[9] = $event => (modal.value.helpers.push({})))
          }, {
            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
              _createTextVNode("+ Autofill", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-xl font-medium mb-2" }, "Restrictions", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modal.value.restrictions.filter(x => !x.destroy), (restriction) => {
            return (_openBlock(), _createBlock(_unref(FormSection), null, {
              default: _withCtx(() => [
                _createVNode(_unref(FormElement), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_unref(SelectInput), {
                          modelValue: restriction.categoryId,
                          "onUpdate:modelValue": $event => ((restriction.categoryId) = $event),
                          options: categories.value.map(x => ({ name: x.attributes.category_name, value: x.id })),
                          name: "Category",
                          class: "mb-2"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]),
                        _createVNode(_unref(InputField), {
                          modelValue: restriction.count,
                          "onUpdate:modelValue": $event => ((restriction.count) = $event),
                          name: "Count"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createVNode(_unref(XCircleIcon), {
                        class: "cursor-pointer h-8 w-8 shrink-0 ml-4 mt-3 hover:text-black",
                        onClick: $event => (restriction.destroy = true)
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 256)),
          _createVNode(_unref(NeueButton), {
            onClick: _cache[10] || (_cache[10] = $event => (modal.value.restrictions.push({})))
          }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
              _createTextVNode("+ Restriction", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-xl font-medium mb-2" }, "Automatic variants", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modal.value.variants.filter(x => !x.destroy), (variant) => {
            return (_openBlock(), _createBlock(_unref(FormSection), null, {
              default: _withCtx(() => [
                _createVNode(_unref(FormElement), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_unref(InputField), {
                          modelValue: variant.key,
                          "onUpdate:modelValue": $event => ((variant.key) = $event),
                          name: "Key"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_unref(InputField), {
                          modelValue: variant.value,
                          "onUpdate:modelValue": $event => ((variant.value) = $event),
                          name: "Value"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createVNode(_unref(XCircleIcon), {
                        class: "cursor-pointer h-8 w-8 shrink-0 ml-4 mt-3 hover:text-black",
                        onClick: $event => (variant.destroy = true)
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 256)),
          _createVNode(_unref(NeueButton), {
            onClick: _cache[11] || (_cache[11] = $event => (modal.value.variants.push({})))
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
              _createTextVNode("+ Variant", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NeueButton), {
          type: "secondary",
          onClick: _cache[12] || (_cache[12] = $event => (modal.value.open = false))
        }, {
          default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(NeueButton), {
          type: modalValid.value ? 'primary' : 'inactive',
          onClick: saveModal
        }, {
          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
            _createTextVNode("Save", -1)
          ]))]),
          _: 1
        }, 8, ["type"])
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 64))
}
}

}